import * as React from 'react';
import * as moment from 'moment';
import { IEventMonth } from '@adage/ace-calendar';
import { ICalendar } from '@adage/calendar/services/calendar';

import { IWACEvent } from '../classes/event';
import GridCell from '../components/grid-cell';

export interface GridMonthProps {
    eventMonth: ICalendar<IWACEvent>;
    monthMoment: moment.Moment;
}

const gridMonth: React.SFC<GridMonthProps> = (props) => {
    // Only display data from the beginning of this week.
    const beginningOfWeek = moment().startOf("week");
    const relevantDays = props.eventMonth.days.filter(day => moment(day.date).startOf("week").isSameOrAfter(beginningOfWeek));

    return (
        <section id={`${props.monthMoment.format("MMMM-YYYY")}-grid-js`} className="grid-month grid-month-js">
            <h2 className="grid-month-name">{props.monthMoment.format("MMMM YYYY")}</h2>

            <div className="grid-month-days">
                {
                    relevantDays.map(day => <GridCell key={Math.random() * 10000} day={day} currentMonth={props.monthMoment} />)
                }
            </div>
        </section>
    );
}

export default gridMonth;


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/calendar/views/grid-month.tsx